import {datasourcestore, DefaultEntity, RestDataSource} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {LanguageEntity} from "./LanguagesStore.js";

export interface DocumentTypeEntity extends DefaultEntity {
	id: string,
	mimetypes: string,
	deleted: boolean,
	languages: DocumentTypeLanguage[]
}

export interface DocumentTypeLanguage extends DefaultEntity {
	id: string,
	documentTypeId: string,
	languageId: string,
	language: LanguageEntity,
	name: string,
	description?: string,
	isDefault: boolean
}

export const documentTypesDS = new RestDataSource<DocumentTypeEntity>(ServerApi.url("elearning/frontend/documentTypes", {
	limit: 0,
	orderColumn: "name",
	returnProperties: "*,mimeTypes,languages[*,name,description,language]"
}, true), "documentTypes");

export const documentTypesStore = datasourcestore({
	dataSource: documentTypesDS
});